/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Machine-readable error code returned in the body of a coded error response. Clients branch on this value, never on the bare HTTP status.
 */
export enum SamplePromptErrorCode {
    ACTIVE_PROMPT_LIMIT_EXCEEDED = 'active_prompt_limit_exceeded',
    FEATURED_PROMPT_LIMIT_EXCEEDED = 'featured_prompt_limit_exceeded',
}
